<template>
  <div>

    <form id="formSiteSetupPassTemps" @change="clearErrors()" class="d-flex flex-column" v-on:submit.prevent="updatePasswordTemplatesSettings">
      <div class="d-flex flex-column tab-card-form">
        <div class="element-info">
          <div class="row align-items-center">
            <div v-if="this.mobile" class="col-sm-8">
              <div class="element-info-with-icon justify-content-center">
                <div class="element-info-text text-center">
                  <h5 class="element-inner-header">Password Templates</h5>
                  <div class="element-inner-desc">Here you can change the Password Templates.</div>
                </div>
              </div>
            </div>
            <div v-else class="col-sm-8">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <fontAwesomeIcon :icon="['fas', 'key']" size="2x" />
                </div>
                <div class="element-info-text ml-5">
                  <h5 class="element-inner-header">Password Templates</h5>
                  <div class="element-inner-desc">Here you can change the Password Templates.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-box d-flex flex-column">
          <b-form-group class="mt-3 align-self-start">
            <b-input-group>
              <b-form-checkbox
                v-model="setupPasswordTemplates.allow_password_reminders"
                name="allow_password_reminders"
                :value="1"
                :unchecked-value="0">
                Allow password reminders
              </b-form-checkbox>
            </b-input-group>
          </b-form-group>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Password reminder subject</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupPasswordTemplates.email_password_reminder_subject" type="text"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <div v-if="this.mobile" slot="description">
                <p>This will be sent when a password reminder is requested.
                The following placeholders can be used:
                </p>
                <ul>
                  <li>[BASE_HREF] - base URL of the site</li>
                  <li>[CLIENT_NAME] - client name</li>
                  <li>[CLIENT_SHORT_NAME] - client short name</li>
                  <li>
                    [PASSWORD] - current password
                  </li>
                </ul>
              </div>
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Password reminder template</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-textarea v-if="this.mobile" class="txtbox-min-h" v-model="setupPasswordTemplates.email_password_reminder" required></b-form-textarea>
                <b-form-textarea v-else id="email_password_reminder" class="txtbox-min-h" v-model="setupPasswordTemplates.email_password_reminder" required></b-form-textarea>
                <b-popover target="email_password_reminder" triggers="focus" title="Tip">
                  <div class="text-size-small">
                    <p>This will be sent when a password reminder is requested.
                    The following placeholders can be used:
                    </p>
                    <ul>
                      <li>[BASE_HREF] - base URL of the site</li>
                      <li>[CLIENT_NAME] - client name</li>
                      <li>[CLIENT_SHORT_NAME] - client short name</li>
                      <li>
                        [PASSWORD] - current password
                      </li>
                    </ul>
                  </div>
                </b-popover>
              </b-input-group>
            </b-form-group>
          </div>

          <b-form-group class="mt-3 align-self-start">
            <b-input-group>
              <b-form-checkbox
                v-model="setupPasswordTemplates.allow_password_resets"
                name="allow_password_resets"
                :value="1"
                :unchecked-value="0">
                Allow password resets
              </b-form-checkbox>
            </b-input-group>
          </b-form-group>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Password reset subject</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupPasswordTemplates.email_password_reset_subject" type="text"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <div v-if="this.mobile" slot="description">
                <p>This will be sent when a password reset is requested.
                The following placeholders can be used:
                </p>
                <ul>
                  <li>[BASE_HREF] - base URL of the site</li>
                  <li>[CLIENT_NAME] - client name</li>
                  <li>[CLIENT_SHORT_NAME] - client short name</li>
                  <li>[PASSWORD] - new password</li>
                  <li>[USERNAME] - user email address</li>
                  <li>[ADMIN_EMAIL] - contact admin email</li>
                </ul>
              </div>
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Password reset template</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-textarea v-if="this.mobile" class="txtbox-min-h" v-model="setupPasswordTemplates.email_password_reset" required></b-form-textarea>
                <b-form-textarea v-else id="email_password_reset" class="txtbox-min-h" v-model="setupPasswordTemplates.email_password_reset" required></b-form-textarea>
                <b-popover target="email_password_reset" triggers="focus" title="Tip">
                  <div class="text-size-small">
                    <p>This will be sent when a password reset is requested.
                    The following placeholders can be used:
                    </p>
                    <ul>
                      <li>[BASE_HREF] - base URL of the site</li>
                      <li>[CLIENT_NAME] - client name</li>
                      <li>[CLIENT_SHORT_NAME] - client short name</li>
                      <li>
                        [PASSWORD] - new password
                      </li>
                      <li>[USERNAME] - user email address</li>
                      <li>[ADMIN_EMAIL] - contact admin email</li>
                    </ul>
                  </div>
                </b-popover>
              </b-input-group>
            </b-form-group>
          </div>

          <b-form-group class="mt-3 align-self-start">
            <b-input-group>
              <b-form-checkbox
                v-model="setupPasswordTemplates.allow_password_hints"
                name="allow_password_hints"
                :value="1"
                :unchecked-value="0">
                Allow password hints
              </b-form-checkbox>
            </b-input-group>
          </b-form-group>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Password hint subject</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupPasswordTemplates.email_password_hint_subject" type="text"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <div v-if="this.mobile" slot="description">
                <p>This will be sent when a password hint is requested.
                The following placeholders can be used:
                </p>
                <ul>
                  <li>[BASE_HREF] - base URL of the site</li>
                  <li>[CLIENT_NAME] - client name</li>
                  <li>[CLIENT_SHORT_NAME] - client short name</li>
                  <li>
                    [PASSWORD_HINT] - password hint
                  </li>
                </ul>
              </div>
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Password hint template</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-textarea v-if="this.mobile" class="txtbox-min-h" v-model="setupPasswordTemplates.email_password_hint" required></b-form-textarea>
                <b-form-textarea v-else id="email_password_hint" class="txtbox-min-h" v-model="setupPasswordTemplates.email_password_hint" required></b-form-textarea>
                <b-popover target="email_password_hint" triggers="focus" title="Tip">
                  <div class="text-size-small">
                    <p>This will be sent when a password hint is requested.
                    The following placeholders can be used:
                    </p>
                    <ul>
                      <li>[BASE_HREF] - base URL of the site</li>
                      <li>[CLIENT_NAME] - client name</li>
                      <li>[CLIENT_SHORT_NAME] - client short name</li>
                      <li>
                        [PASSWORD_HINT] - password hint
                      </li>
                    </ul>
                  </div>
                </b-popover>
              </b-input-group>
            </b-form-group>
          </div>
          <transition name="fade">
            <ResponseInfo v-if="getResponseInfo.name == 'siteSetupPassword'" class="mt-3"/>
          </transition>
          <button v-if="!this.mobile" class="btn btn-primary mt-3 align-self-end" type="submit" value="submit">Update</button>
          <button v-else class="btn btn-secondary mt-3 align-self-end" type="submit" value="submit">Update</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default{
  name: 'SiteSetupPasswordTemplates',
  components: {
      ResponseInfo,
      ValidationErrors
  },
  data() {
    return {
      setupPasswordTemplates: {},
      mobile: window.innerWidth <= 700
    }
  },
  created() {
    passwordTemplatesSettings:{
        this.$store.dispatch('getPasswordTemplatesSettings')
        .then(() => {
            if(Object.keys(this.passwordTemplatesSettings).length){
                this.setupPasswordTemplates = Object.assign({}, this.passwordTemplatesSettings)
            }
        })
    }
    window.addEventListener('resize', () => {
          this.mobile = window.innerWidth <= 700
    })
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getUserDetails','getIsNewsnet', 'getPasswordTemplatesSettings', 'getResponseInfo']),
      passwordTemplatesSettings:{
          get() {
              return this.$store.getters.getPasswordTemplatesSettings
          }
      }
  },
  methods: {
    clearErrors() {
      //clearing the error message when we change the input
      this.$store.commit('setValidationErrors', [])
    },
    updatePasswordTemplatesSettings(){
      this.$store.dispatch('setPasswordTemplatesSettings',{
          data: this.setupPasswordTemplates
      })
    }
  }
}
</script>

<style lang="css" scoped>
.tab-card-form{
  min-width: 70%;
}
.txtbox-min-h{
  min-height: 150px;
}
.pretext{
  display: flex;
  align-items: center;
  justify-content: center;
}
.pretext-span{
  width: 100%;
  white-space: normal;
}
.text-size-small{
  font-size: 0.8rem;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
